import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetAllUsers } from "../../../../api/adduser";

const UsersPage = () => {
  const { data: usersData, isLoading, isError } = useGetAllUsers();
  const navigate = useNavigate();

  // since API returns an array directly
  const users = usersData || [];

  if (isLoading) return <p className="text-gray-500">Loading users...</p>;
  if (isError) return <p className="text-red-500">Failed to load users</p>;

  return (
    <div className="p-1">
      <h2 className="text-xl font-bold mb-4">All Users</h2>

      <div className="overflow-x-auto hide-scrollbar">
        <table className="min-w-[1000px] w-full table-auto border border-gray-200">
          <thead className="bg-gray-100 text-left text-sm font-semibold text-gray-700">
            <tr>
              <th className="p-3">Name</th>
              <th className="p-3">Email</th>
              <th className="p-3">Phone</th>
              <th className="p-3">Company</th>
              <th className="p-3">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white text-sm">
            {users.length > 0 ? (
              users.map((user) => (
                <tr key={user._id} className="border-b hover:bg-gray-50">
                  <td className="p-3">
                    {user.firstName} {user.lastName}
                  </td>
                  <td className="p-3">{user.email}</td>
                  <td className="p-3">{user.mobile}</td>
                  <td className="p-3">{user.companyName}</td>
                  <td className="p-3">
                    <button
                      onClick={() => navigate(`/users/${user._id}/orders`)}
                      className="px-3 py-1 hover:bg-primary hover:text-white rounded bg-white text-black border border-primary"
                    >
                      View Orders
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center py-6 text-gray-400">
                  No users found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersPage;
